import { useRoutes } from "react-router-dom";

import globalRoutes from "./routes/global";

const App = () => useRoutes(globalRoutes);

export default App;
